import { render, staticRenderFns } from "./CardZuursel.vue?vue&type=template&id=1042991b&scoped=true"
import script from "./CardZuursel.vue?vue&type=script&lang=js"
export * from "./CardZuursel.vue?vue&type=script&lang=js"
import style0 from "./CardZuursel.vue?vue&type=style&index=0&id=1042991b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1042991b",
  null
  
)

export default component.exports